var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrthopedic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "1.8 1.8 28 28",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20.983,21.128 c-1.151-2.586-3.163-4.465-3.23-7.303c-1.138-0.192-1.994-0.259-1.994-0.259c-3.974,0.555-6.192,1.92-6.192,1.92 c-2.194,1.487-1.843,7.667-1.866,12.59h13.359l-0.269-5.224C20.274,22.948,21.206,21.627,20.983,21.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.511,13.702c0,0,3.385,0.189,5.717,1.566 c0.251,0.148,0.454,0.363,0.591,0.62c0.476,0.894,1.489,3.405,1.618,8.745c0.003,0.105-0.004,0.212-0.023,0.315 c-0.102,0.555-0.609,1.948-3.131,1.173"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.21,14.253 c-0.41-1.169-0.784-2.598-0.81-2.955c-0.222,0.046-0.448,0.069-0.675,0.064c-0.201-0.005-0.398-0.018-0.593-0.034l0-0.009 c-0.02,0.002-0.04,0.003-0.06,0.004c-0.02-0.002-0.04-0.003-0.06-0.005v0.009c-0.195,0.014-0.392,0.025-0.593,0.028 c-0.227,0.003-0.453-0.023-0.675-0.071c-0.029,0.357-0.419,1.782-0.842,2.946c-0.568,1.567,1.756,1.606,2.146,1.602 C16.437,15.84,18.761,15.826,18.21,14.253z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 20.465,
    y1: 21.571,
    x2: 20.351,
    y2: 18.34
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "12.635,14.238 16.115,21.919  14.753,21.919 11.422,14.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "18.817,14.03 18.638,22.907  19.889,22.372 20.101,14.356  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161B43"
    },
    d: "M14.395,11.833c0.112,0.683,0.834,1.211,1.71,1.211c0.876,0,1.597-0.528,1.709-1.211H14.395z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.225,8.842 c-0.008-0.6,0.172-1.089,0.55-1.094c0.066-0.001,0.133,0.014,0.199,0.04C12.96,7.621,12.951,7.5,12.948,7.449 c-0.002-0.02-0.002-0.04-0.002-0.06c0-0.004,0-0.01,0-0.015c0,0,0,0,0,0c0-0.011,0.001-0.023,0.001-0.037 c0-0.005,0-0.01,0.001-0.016c0-0.011,0.001-0.023,0.002-0.036c0-0.009,0.001-0.019,0.002-0.029 c0.001-0.011,0.002-0.022,0.002-0.034c0.001-0.013,0.002-0.027,0.003-0.041c0.001-0.011,0.002-0.022,0.003-0.034 c0.002-0.017,0.004-0.035,0.006-0.053c0.001-0.011,0.002-0.021,0.004-0.032c0.002-0.021,0.005-0.042,0.008-0.064 c0.001-0.01,0.003-0.021,0.004-0.031c0.003-0.024,0.007-0.049,0.011-0.074c0.002-0.01,0.003-0.019,0.005-0.03 c0.005-0.027,0.01-0.055,0.015-0.083c0.002-0.01,0.003-0.019,0.005-0.029c0.006-0.029,0.012-0.059,0.019-0.09 c0.002-0.009,0.004-0.019,0.006-0.028c0.007-0.032,0.015-0.064,0.024-0.097c0.002-0.009,0.004-0.018,0.007-0.027 c0.009-0.034,0.018-0.068,0.028-0.102c0.003-0.009,0.005-0.018,0.008-0.027c0.01-0.035,0.022-0.07,0.033-0.105 c0.003-0.009,0.006-0.018,0.009-0.028c0.012-0.036,0.025-0.072,0.039-0.109c0.003-0.009,0.007-0.018,0.01-0.027 c0.014-0.037,0.029-0.073,0.045-0.11c0.004-0.009,0.007-0.018,0.012-0.028c0.016-0.037,0.033-0.074,0.051-0.111 c0.004-0.009,0.009-0.019,0.013-0.028c0.018-0.037,0.037-0.074,0.057-0.11c0.005-0.01,0.01-0.019,0.015-0.029 c0.02-0.036,0.042-0.073,0.063-0.109c0.006-0.01,0.011-0.02,0.017-0.029c0.022-0.036,0.046-0.071,0.07-0.107 c0.007-0.01,0.013-0.02,0.02-0.03c0.024-0.035,0.05-0.069,0.076-0.103c0.008-0.01,0.015-0.02,0.023-0.03 c0.027-0.033,0.055-0.066,0.083-0.099c0.009-0.01,0.017-0.021,0.027-0.031c0.029-0.032,0.059-0.063,0.09-0.094 c0.01-0.01,0.02-0.021,0.031-0.031c0.031-0.03,0.063-0.059,0.096-0.088c0.012-0.01,0.023-0.021,0.035-0.032 c0.033-0.028,0.068-0.055,0.103-0.082c0.014-0.01,0.026-0.021,0.04-0.031c0.035-0.026,0.072-0.05,0.11-0.075 c0.015-0.01,0.03-0.021,0.045-0.03c0.037-0.023,0.077-0.045,0.116-0.068c0.017-0.01,0.034-0.02,0.051-0.029 c0.04-0.021,0.081-0.04,0.123-0.06c0.019-0.009,0.038-0.019,0.058-0.028c0.042-0.018,0.086-0.035,0.13-0.052 c0.021-0.008,0.042-0.017,0.064-0.025c0.043-0.016,0.089-0.029,0.135-0.043c0.024-0.008,0.048-0.016,0.073-0.023 c0.046-0.013,0.095-0.024,0.143-0.035c0.026-0.006,0.052-0.013,0.079-0.019c0.05-0.01,0.102-0.018,0.153-0.026 c0.028-0.004,0.055-0.01,0.084-0.014c0.055-0.007,0.113-0.012,0.17-0.018c0.028-0.003,0.054-0.007,0.082-0.009 c0.087-0.006,0.176-0.01,0.268-0.011c0.089-0.001,0.175,0.001,0.259,0.004c0.028,0.001,0.054,0.004,0.081,0.006 c0.055,0.004,0.111,0.007,0.164,0.013c0.031,0.003,0.06,0.008,0.09,0.012c0.047,0.006,0.095,0.012,0.141,0.02 c0.031,0.005,0.06,0.011,0.09,0.017c0.043,0.009,0.086,0.017,0.128,0.027c0.029,0.007,0.058,0.015,0.086,0.023 c0.04,0.011,0.08,0.022,0.119,0.034c0.027,0.009,0.054,0.017,0.08,0.027c0.038,0.013,0.076,0.027,0.113,0.042 c0.025,0.01,0.049,0.02,0.074,0.03c0.037,0.016,0.073,0.032,0.108,0.049c0.022,0.011,0.044,0.021,0.066,0.032 c0.036,0.019,0.071,0.038,0.106,0.058c0.019,0.011,0.038,0.021,0.056,0.032c0.037,0.023,0.073,0.046,0.108,0.07 c0.014,0.009,0.028,0.018,0.042,0.028c0.043,0.03,0.085,0.062,0.125,0.094c0.005,0.004,0.01,0.007,0.014,0.011 c0.091,0.074,0.175,0.152,0.253,0.234c0.007,0.008,0.014,0.016,0.021,0.023c0.03,0.033,0.06,0.066,0.088,0.099 c0.01,0.012,0.019,0.023,0.028,0.035c0.025,0.031,0.049,0.061,0.072,0.092c0.01,0.013,0.019,0.026,0.028,0.039 c0.022,0.03,0.043,0.06,0.063,0.091c0.009,0.014,0.018,0.028,0.027,0.042c0.019,0.03,0.038,0.06,0.056,0.091 c0.008,0.014,0.016,0.028,0.024,0.042c0.017,0.031,0.034,0.062,0.051,0.092c0.007,0.014,0.015,0.028,0.022,0.041 c0.016,0.032,0.031,0.063,0.046,0.094c0.006,0.013,0.012,0.026,0.018,0.038c0.015,0.033,0.03,0.067,0.044,0.1 c0.004,0.011,0.009,0.021,0.014,0.032c0.015,0.037,0.029,0.074,0.043,0.11c0.003,0.007,0.005,0.013,0.008,0.02 c0.032,0.088,0.06,0.174,0.084,0.257c0.001,0.002,0.001,0.004,0.002,0.006c0.011,0.038,0.021,0.076,0.031,0.112 c0.003,0.011,0.005,0.022,0.008,0.032c0.007,0.027,0.013,0.054,0.019,0.081c0.003,0.014,0.006,0.028,0.009,0.041 c0.005,0.022,0.009,0.044,0.014,0.065c0.003,0.015,0.006,0.03,0.008,0.045c0.003,0.019,0.007,0.037,0.01,0.055 c0.003,0.016,0.005,0.031,0.008,0.046c0.003,0.015,0.005,0.03,0.007,0.045c0.003,0.016,0.005,0.032,0.007,0.048 c0.002,0.012,0.003,0.023,0.005,0.034c0.002,0.017,0.004,0.033,0.006,0.048c0.001,0.008,0.002,0.015,0.002,0.023 c0.002,0.017,0.004,0.034,0.005,0.05c0,0,0,0.001,0,0.001l0,0c0.006,0.061,0.009,0.109,0.01,0.137c0.001,0.02,0.001,0.04,0,0.06 c-0.002,0.051-0.008,0.172-0.017,0.34c0.066-0.028,0.132-0.045,0.198-0.045c0.378-0.005,0.571,0.479,0.578,1.079 c0.008,0.568-0.561,1.042-0.942,1.094c-0.064,0.565-0.16,1.05-0.244,1.253c-0.367,0.894-1.726,1.604-2.629,1.616 c-0.903,0.012-1.994-0.455-2.717-1.546c-0.122-0.183-0.198-0.684-0.277-1.247C12.813,9.868,12.232,9.41,12.225,8.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.028,8.006l0.49,1.595 c0,0,0.044,0.365-0.287,0.387h-0.525"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.553,11.035c0,0,0.763,0.31,1.239-0.044"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M15.722,3.339c2.917-0.868,3.181,1.662,3.181,1.662s0.477,0.19,0.685,0.571 c0.208,0.381-0.09,2.42-0.662,3.173c-0.438-0.672-0.58-2.659-0.58-2.659c-1.164-0.441-4.643-0.011-4.643-0.011 s0.069,2.112-0.541,2.602C11.895,5.927,13.082,4.125,15.722,3.339z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 11.327,
    y1: 28.04,
    x2: 11.213,
    y2: 18.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.628,26.414l-0.465-0.241l-2.566-0.073 c0,0-0.701-1.875-0.673-1.924c0.028-0.049,0.184-0.654,0.184-0.654s1.574,0.152,1.63,0.123c0.056-0.028-0.972-2.048,0.237-1.021 l2.209,1.435l1.621,1.628L14.628,26.414z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 10.924,
    y1: 24.175,
    x2: 11.507,
    y2: 24.186
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 11.192,
    y1: 24.986,
    x2: 11.954,
    y2: 24.983
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 11.43,
    y1: 25.702,
    x2: 12.022,
    y2: 25.693
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M24.461,21.556h-9.48 c-0.951,0-1.73,0.778-1.73,1.73v3.249h9.737c0.813,0,1.473-0.659,1.473-1.473V21.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.55,25.944 c0,1.609-1.304,2.913-2.913,2.913c-1.609,0-2.913-1.304-2.913-2.913c0-1.609,1.304-2.913,2.913-2.913 C22.246,23.031,23.55,24.335,23.55,25.944z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "22.25,25.259 21.309,25.259  21.309,24.317 20.016,24.317 20.016,25.259 19.075,25.259 19.075,26.552 20.016,26.552 20.016,27.493 21.309,27.493 21.309,26.552  22.25,26.552  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrthopedic);
export default __webpack_public_path__ + "static/media/orthopedic.3cc95047c8ca8378b1989d41fbd835f4.svg";
export { ForwardRef as ReactComponent };